import FormLayoutGenerator, { FieldConfig } from '../../../FormLayoutGenerator';

const FIELDS: FieldConfig[] = [
  { label: 'hour_label', name: 'finSalNomHour', cols: 12 },
  { label: 'duty_label', name: 'finSalNomDuty', cols: 12 },
  { label: 'buh_hour', name: 'finSalNomBuhHour', cols: 12 },
  { label: 'buh1_hour', name: 'finSalNomBuh1Hour', cols: 12 },
  { label: 'buh2_hour', name: 'finSalNomBuh2Hour', cols: 12 },
  { label: 'buh3_hour', name: 'finSalNomBuh3Hour', cols: 12 },
  { label: 'buh4_hour', name: 'finSalNomBuh4Hour', cols: 12 },
  { label: 'buh5_hour', name: 'finSalNomBuh5Hour', cols: 12 },
  { label: 'buh6_hour', name: 'finSalNomBuh6Hour', cols: 12 }
];

const NominalCalculationValues = () => {
  return (
    <>
      <FormLayoutGenerator
        fieldConfigs={FIELDS}
        translateKeyPrefix="employerCostSettings"
      />
    </>
  );
};

export default NominalCalculationValues;
